import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Grid,
  Typography,
  Button
} from '@material-ui/core';

const NotFound = (props) => {

    return (
        <>
        <Grid
            container
            direction="row"
            style={{ backgroundColor: '#fff', height: '100%' }}
            >
            <Grid
              item
              md={12}
              style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', paddingBottom: '4rem'}}
            >
              <Typography
                variant="h2"
                style={{
                  fontWeight: '900',
                  fontSize: '10rem',
                  color: '#b5b5b5'
                }}
              >
                404
              </Typography>
              <Typography 
                variant="h5"
                style={{
                  fontWeight: '600',
                  textTransform: 'uppercase'
                }}>
                oops, sorry we can&rsquo;t find that page!
              </Typography>
              <Typography 
                style={{
                  marginTop: '5px',
                }}>
                Either something went wrong or the page dosen&rsquo;t exist anymore
              </Typography>

              <hr style={{width: '470px', marginTop: '20px'}} />
              
              <Button
                margin="normal"
                variant="contained"
                color="primary"
                onClick={() => { props.history.push('/') }} 
                style={{textTransform: 'uppercase', marginTop: '15px'}}
              >
                Home Page
              </Button>
            </Grid>
        </Grid>
        </>
    )
}

export default withRouter(NotFound);